import { HttpInterceptorFn, HttpParams } from '@angular/common/http';

/**
 * Converts POST requests with a plain JS object body into
 * application/x-www-form-urlencoded bodies.
 *
 * Rationale: legacy backend endpoints (e.g. /saveJsonObject, /loadJsonObject)
 * read request parameters as form fields and fail with errors like
 * "Required (tax_year, scenario, jcd_key, scenarioCode, is_issue_key_enabled)
 * configuration is missing" when Angular posts a plain object with the default
 * Content-Type: application/json. This interceptor centrally normalizes such
 * requests so they appear as "Form Data" (x-www-form-urlencoded) in DevTools
 * and match the backend contract.
 */
export const formEncodeInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'POST') {
    return next(req);
  }

  if (req.url.includes('gtw-websockets')) {
    return next(req);
  }

  if (req.headers.has('Content-Type')) {
    return next(req);
  }

  const body = req.body;

  if (body === null || body === undefined) {
    return next(req);
  }
  if (typeof body === 'string') {
    return next(req);
  }
  if (body instanceof FormData) {
    return next(req);
  }
  if (body instanceof URLSearchParams) {
    return next(req);
  }
  if (typeof Blob !== 'undefined' && body instanceof Blob) {
    return next(req);
  }
  if (typeof ArrayBuffer !== 'undefined' && body instanceof ArrayBuffer) {
    return next(req);
  }
  if (body instanceof HttpParams) {
    return next(req);
  }
  if (typeof body !== 'object') {
    return next(req);
  }

  const encoded = new URLSearchParams();
  Object.keys(body).forEach((key) => {
    const value = (body as any)[key];
    if (value === null || value === undefined) {
      return;
    }
    encoded.append(
      key,
      typeof value === 'object' ? JSON.stringify(value) : String(value)
    );
  });

  return next(
    req.clone({
      body: encoded.toString(),
      setHeaders: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    })
  );
};
